import { ReactNode, useState } from "react";
import {
  Button,
  Drawer,
  DrawerOverlay,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  ModalProps,
} from "@chakra-ui/react";
import { AddIcon } from "@chakra-ui/icons";
import CreateRetailer from "./Create";
import RetailerDrawerContent from "./DrawerContent";
import RetailerDirectory, { RetailerDirectoryProps } from ".";

const NEW_ID = "__NEW__";

type Props = Omit<ModalProps, "children"> &
  Pick<
    RetailerDirectoryProps,
    "columns" | "filter" | "isAdmin" | "pinnedColumns" | "meta"
  > & {
    renderDrawerFooter?: (props: { retailerId: UUID }) => ReactNode;
  };

export default function RetailerDirectoryModal({
  columns,
  filter,
  isAdmin,
  meta,
  pinnedColumns,
  renderDrawerFooter,
  ...rest
}: Props) {
  const [selectedRetailerId, setSelectedRetailerId] = useState<UUID | null>(
    null,
  );
  return (
    <>
      <Modal {...rest} size="6xl" blockScrollOnMount={false}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Retailer Directory</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <RetailerDirectory
              {...{ columns, filter, isAdmin, pinnedColumns, meta }}
              selected={selectedRetailerId}
              onSelectedChange={setSelectedRetailerId}
            />
          </ModalBody>
          <ModalFooter justifyContent="center">
            <Button
              size="sm"
              colorScheme="pinkButton"
              leftIcon={<AddIcon />}
              onClick={() => setSelectedRetailerId(NEW_ID)}
            >
              Add New Retailer
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Drawer
        isOpen={!!selectedRetailerId}
        placement="right"
        onClose={() => setSelectedRetailerId(null)}
        size="sm"
        blockScrollOnMount={false}
      >
        <DrawerOverlay />
        {selectedRetailerId === NEW_ID ? (
          <CreateRetailer
            isAdmin={isAdmin}
            onCloseEdit={() => setSelectedRetailerId(null)}
            onCompleted={(newId) => setSelectedRetailerId(newId)}
          />
        ) : (
          <RetailerDrawerContent
            isAdmin={isAdmin}
            onClose={() => setSelectedRetailerId(null)}
            onSelectedRetailerIdChange={setSelectedRetailerId}
            selectedRetailerId={selectedRetailerId}
            footer={
              selectedRetailerId &&
              renderDrawerFooter?.({ retailerId: selectedRetailerId })
            }
          />
        )}
      </Drawer>
    </>
  );
}
